/*
 * COPYRIGHT © 2026 SANITÀNEXUS WHITE-LABEL. ALL RIGHTS RESERVED.
 * AUTHOR AND SOLE DEVELOPER: MARCO PANZETTI (C.F. PNZMRC89M14F251C)
 * Protected under Italian Copyright Law (Legge 633/1941) and International Treaties.
 * Unauthorized copying, reverse engineering, or distribution of this software architecture,
 * UI/UX layouts, local-first logic, or system prompt configurations is strictly prohibited.
 */
import api from '@/lib/api';

// -------- Reviews --------
export const canReviewAppointment = (appointmentId) =>
  api.get(`/marketplace/appointments/${appointmentId}/can-review`).then((r) => r.data);

export const createReview = (payload) =>
  api.post('/marketplace/reviews', payload).then((r) => r.data);

export const listDoctorReviews = (doctorId) =>
  api.get(`/marketplace/reviews/doctor/${doctorId}`).then((r) => r.data);

export const listMyReviews = () =>
  api.get('/marketplace/reviews/mine').then((r) => r.data);

export const replyReview = (reviewId, reply) =>
  api.post(`/marketplace/reviews/${reviewId}/reply`, { reply }).then((r) => r.data);

// -------- Second Opinions --------
export const requestSecondOpinion = (payload) =>
  api.post('/marketplace/second-opinions', payload).then((r) => r.data);

export const listMySecondOpinions = () =>
  api.get('/marketplace/second-opinions/mine').then((r) => r.data);

export const getSecondOpinion = (id) =>
  api.get(`/marketplace/second-opinions/${id}`).then((r) => r.data);

export const respondSecondOpinion = (id, payload) =>
  api.post(`/marketplace/second-opinions/${id}/respond`, payload).then((r) => r.data);

export const updateSecondOpinionStatus = (id, status, note) =>
  api.post(`/marketplace/second-opinions/${id}/status`, { status, note }).then((r) => r.data);

export const cancelSecondOpinion = (id) =>
  api.delete(`/marketplace/second-opinions/${id}`).then((r) => r.data);

// -------- FHIR --------
export const fhirEverything = (patientId) =>
  api.get(`/fhir/Patient/${patientId}/everything`).then((r) => r.data);

export const fhirPrescriptionsBundle = (patientId) =>
  api.get(`/fhir/Patient/${patientId}/prescriptions`).then((r) => r.data);

export const fhirDocumentsBundle = (patientId) =>
  api.get(`/fhir/Patient/${patientId}/documents`).then((r) => r.data);
